import React from "react"
import Layout from "../components/Layout"
import WorkDisplay from "../components/WorkDisplay"

const work = () => {
    return (
        <Layout>
            <WorkDisplay />
        </Layout>
    )
}

export default work
